var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{style:(_vm.style),on:{"click":_vm.onClick}},[_c('font-awesome-icon',{staticClass:"button-stop",attrs:{"icon":"minus-circle"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }